import { requester } from '../utils';

export const getTakeawayFactor = (query) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/takeaway/factor?${query}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('get takeaway factor error', err);
        reject(err);
      });
  });
};